import { ImageOff } from "lucide-react";
import Image, { type ImageProps } from "next/image";
import { cn } from "@/lib/utils";

const ExtendedImage = ({ src, alt, className, ...props }: ImageProps) => {
  if (!src || (typeof src === "string" && src.length === 0)) {
    return (
      <div
        className={cn(
          "bg-gray-200 w-full flex-1 h-full justify-center items-center flex",
          className,
        )}
      >
        <ImageOff className="stroke-gray-400" size={40} />
      </div>
    );
  }
  return (
    <Image
      alt={alt}
      className={cn("object-cover", className)}
      draggable="false"
      src={src}
      {...props}
    />
  );
};

export default ExtendedImage;
